export const wTwitterFollowMetaData = {
    isRepeatable: false
}
